import { CONSTRUCTION_AUTODESK_URL } from '../../../helpers/const';

export const PRICING_URL = `${CONSTRUCTION_AUTODESK_URL}/pricing`;
